import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth";
import api from "assets/services/api";


function ModalDeleteSell(props) {
  const [br, setBR] = useState(false);
  const [controlSnack, setControlSnack] = useState(false);
  const {storageId} = useAuth();

  useEffect(() => {
    if (controlSnack) showNotification("br");
  }, [controlSnack]);


  async function handleDeleteStorage(e) {
    e.preventDefault();
    const response = await api.delete('/sell/cancel/note/'+ props.props.nf +'/'+storageId, {
    });
    if (response.status === 200) {
      setControlSnack(true);
      props.onHide();
      props.loadTotal();
      props.loadSell();
    }
  }

  const showNotification = place => {
    switch (place) {
      case "br":
        if (!br) {
          setBR(true);
          setTimeout(function () {
            setBR(false);
            setControlSnack(false);
          }, 6000);
        }
        break;
      default:
        break;
    }
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Cancelar venda
          </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleDeleteStorage}>
        <Modal.Body>
        <h4> Tem certeza que deseja cancelar essa venda? Caso cancele, o pedido também será cancelado e um novo pedido deverá ser efetuado</h4>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button color="success" type="submit">
              Deletar
          </Button>
            <Snackbar
              place="br"
              color="success"
              icon={AddAlert}
              message="Venda cancelada com sucesso"
              open={br}
              closeNotification={() => setBR(false)}
              close
            />
          </div>
        </Modal.Footer>
        </Form>
    </Modal>
  );
}

export default ModalDeleteSell;